import React from 'react';
import { AiFillDollarCircle, AiFillStar } from 'react-icons/ai';

import ConnectorGroup from './ConnectorGroup/ConnectorGroup';
import classNames from 'classnames';

import classes from './ChargingPointPopup.module.scss';
import { GroupedConnectors } from './ChargingPointPopup.model';
import { MdPlace } from 'react-icons/md';

type Props = {
  name?: string;
  operatorName?: string;
  updateAt?: number;
  groupOfconnectors?: GroupedConnectors[];
  address?: string;
};

const ChargingPointPopupView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <div className={classes['container']}>
      <div className={classes['content']}>
        <div className={classes['headerWrapper']}>
          <div className={classes['imgWrapper']}>
            <img className={classes['img']} src="/images/connectors/car-image.svg"></img>
          </div>

          <div className={classes['detailsWrapper']}>
            <div className={classes['name']}>{props.name}</div>
            <div className={classes['operatorName']}>{props.operatorName}</div>
            <div className={classes['addressWrapper']}>
              <MdPlace size={30} />
              <div className={classes['address']}>{props.address}</div>
            </div>
            <div className={classes['kwPriceWrapper']}>
              <div className={classes['iconWrapper']}>
                <AiFillDollarCircle className={classes['icon']} size={17} />
              </div>
              <div className={classes['kwPriceValueWrapper']}>
                <div className={classes['kwPriceValue']}>
                  <span className={classNames(classes['kwPriceValue'], classes['kwPriceValue__beforeDecimal'])}>9</span>
                  <span className={classNames(classes['kwPriceValue'], classes['kwPriceValue__afterDecimal'])}>.28</span>
                  <span className={classNames(classes['kwPriceValue'], classes['kwPriceValue__measureAmount'])}>/kW</span>
                </div>
              </div>
            </div>
          </div>
          <div className={classes['rate']}>
            <AiFillStar className={classNames(classes['rate'], classes['rate__icon'])}></AiFillStar>
            <span className={classNames(classes['rate'], classes['rate__value'])}>4.6</span>
          </div>
        </div>
        <div className={classes['body']}>
          {props.groupOfconnectors?.map((connectorGroup: GroupedConnectors, index: number) => (
            <ConnectorGroup
              key={index}
              address={props.address}
              type={connectorGroup.type}
              available={connectorGroup.available}
              total={connectorGroup.total}
              maxVoltage={connectorGroup.maxVoltage}
            ></ConnectorGroup>
          ))}
        </div>
      </div>
    </div>
  );
};

ChargingPointPopupView.displayName = 'ChargingPointPopupView';
ChargingPointPopupView.defaultProps = {};

export default ChargingPointPopupView;
